import { ReactElement } from "react";
import { alpha, Box } from "@mui/material";
import AudioFileIcon from "@mui/icons-material/AudioFile";
import CodeIcon from "@mui/icons-material/Code";
import FolderIcon from "@mui/icons-material/Folder";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import ImageIcon from "@mui/icons-material/Image";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import PdfIcon from "@mui/icons-material/PictureAsPdf";
import VideoFileIcon from "@mui/icons-material/VideoFile";

function iconSpec(contentType: string): [ReactElement, string] {
  if (contentType === "application/x-directory")
    return [<FolderIcon />, "#f7b52c"];
  if (contentType.startsWith("image/")) return [<ImageIcon />, "#07c160"];
  if (contentType.startsWith("video/")) return [<VideoFileIcon />, "#9a5df2"];
  if (contentType.startsWith("audio/")) return [<AudioFileIcon />, "#fa8c16"];
  if (contentType === "application/pdf") return [<PdfIcon />, "#fa5151"];
  if (["application/zip", "application/gzip"].includes(contentType))
    return [<FolderZipIcon />, "#b57c46"];
  if (contentType.startsWith("text/")) return [<CodeIcon />, "#10aeff"];
  return [<InsertDriveFileIcon />, "#909399"];
}

function MimeIcon({ contentType }: { contentType: string }) {
  const [icon, color] =
    typeof contentType === "string"
      ? iconSpec(contentType)
      : iconSpec("application/octet-stream");

  return (
    <Box
      sx={{
        width: 40,
        height: 40,
        borderRadius: "10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: alpha(color, 0.14),
        color,
      }}
    >
      {icon}
    </Box>
  );
}

export default MimeIcon;
